import axios from "axios";

const state = {
  brands: [],
};

const getters = {};

const actions = {
  getBrands({ commit }) {
    return axios
      .get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/brands", {
        params: {
          itemsPerPage: 1000,
          //"filter[is_active]": 1,
        },
      })
      .then((response) => {
        commit("setBrands", response.data.data || []);
      });
  },
  createBrand({ dispatch }, payload) {
    return axios
      .post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/brands", payload)
      .then((response) => {
        dispatch("getBrands");
        return response;
      });
  },
};

const mutations = {
  setBrands(state, data) {
    state.brands = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
